import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { BaseListItemMenuComponent } from '../../../../../shared/base-classes/base-list-item-menu.component';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { VehicleDeleteButtonComponent } from '../vehicle-delete-button/vehicle-delete-button.component';
import { VehicleStatusButtonComponent } from '../vehicle-status-button/vehicle-status-button.component';

@Component({
	selector: 'app-vehicles-list-item-menu',
	templateUrl: 'vehicles-list-item-menu.component.html',
	imports: [
		VehicleDeleteButtonComponent,
		ListItemMenuContainerComponent,
		VehicleStatusButtonComponent,
		IonicModule,
	],
})
export class VehiclesListPortalComponent extends BaseListItemMenuComponent {}
